import { ExchanegeRateService } from '@acme/api';
import { Icon } from '@acme/assets';
import { ClientExchangeRateResponse } from '@acme/domains';
import { ResultModal, TextAreaModal, useModal } from '@acme/foundation';
import { Button, Dropdown, DropdownItem } from 'flowbite-react';
import { useNavigate } from 'react-router-dom';
import { ExchangeRateForm } from './exchangeRateForm';

interface IAdminActionMenu {
  rowData: ClientExchangeRateResponse;
}

export const AdminActionMenu = (props: IAdminActionMenu) => {
  const { openModal, closeModal } = useModal();
  const navigate = useNavigate();

  const onBlockRate = (comment: string) => {
    ExchanegeRateService.putApiV1ExchanegeRateBlock({
      requestBody: {
        rateId: props.rowData.rateId,
        comment,
      },
    })
      .then(() => {
        openModal({
          content: (
            <ResultModal
              title={'Успешно'}
              description="Курс валюты был заблокирован"
              type={'success'}
              onBack={() => {
                closeModal();
              }}
            />
          ),
          opaqueBackground: true,
        });
      })
      .catch(() => {
        openModal({
          content: (
            <ResultModal
              title="Заблокировать курс не удалось"
              description={'Попробуйте повторить позднее'}
              type={'error'}
              onBack={() => {
                navigate('/rates');
                closeModal();
              }}
            />
          ),
          opaqueBackground: true,
        });
      });
  };

  const handleBlockRateClick = () => {
    openModal({
      content: (
        <TextAreaModal
          title="Блокировка курса"
          areaLabel="Запросить повторное подтверждение"
          approveButtonText="Заблокировать"
          onClose={closeModal}
          onApprove={(value) => {
            closeModal();
            onBlockRate(value);
          }}
        />
      ),
      modalType: 'custom',
    });
  };
  const handleCorrectRateClick = () => {
    openModal({
      content: (
        <ExchangeRateForm
          onClose={closeModal}
          onSubmit={ExchanegeRateService.putApiV1ExchanegeRateUpdateAdmin}
          defaultData={props.rowData}
          adminMode
        />
      ),
      size: 'xl',
      modalType: 'custom',
    });
  };

  return (
    <Dropdown
      label=""
      dismissOnClick={false}
      placement="right-start"
      renderTrigger={() => (
        <Button
          size="sm"
          color="gray"
          className="px-2 py-1 bg-transparent hover:bg-transparent"
        >
          <Icon name="dots-horizontal-outline" />
        </Button>
      )}
    >
      <DropdownItem
        className="text-sm font-medium text-gray-900 py-2 px-3 min-w-[200px]"
        onClick={handleCorrectRateClick}
      >
        Скорректировать курс
      </DropdownItem>
      <DropdownItem
        className="text-sm font-medium text-gray-900 py-2 px-3"
        onClick={handleBlockRateClick}
      >
        Заблокировать курс
      </DropdownItem>
    </Dropdown>
  );
};
